export default __webpack_public_path__ + "static/media/safari-browser-logo.450e3a9c.png";